import { getSystemInfo, getUserCertificates } from 'crypto-pro-actual-cades-plugin';
import { defineStore } from 'pinia';

interface ICertificatesState {
  certificates0: any[];
  pluginInfo0: any;
}

export const useCertificatesStore = defineStore('certificates', {
  state: (): ICertificatesState => ({
    certificates0: [],
    pluginInfo0: null,
  }),

  getters: {
    certificates: (state) => state.certificates0,
    pluginInfo: (state) => state.pluginInfo0,
  },

  actions: {
    async getCertificates() {
      try {
        const certificates = await getUserCertificates();
        this.certificates0 = certificates;
      } catch (error) {
        console.error(error);
      }
    },

    async getPluginInfo() {
      try {
        const pluginInfo = await getSystemInfo();
        this.pluginInfo0 = pluginInfo;
      } catch (error) {
        console.error(error);
      }
    },

    setCertificates(data: any[] = []) {
      this.certificates0 = data;
    },

    setPluginInfo(data: any = null) {
      this.pluginInfo0 = data;
    },
  },
});

export default useCertificatesStore;
